import { isTopEmbeddedLeadFormEnabled } from 'site-modules/shared/utils/inventory/build-lead-target-preload-enabled';
import { checkDealerSupportsCTA } from 'site-modules/shared/utils/inventory/usurp-inventory-card';

/**
 * @param vinData
 * @param disableDrivewayNewCarLeadForms
 * @returns {boolean} true, when embedded lead form is shown. false, when not shown.
 */
export const getEmbdLF = ({ vinData, disableDrivewayNewCarLeadForms, location }) => {
  if (!checkDealerSupportsCTA({ vehicle: vinData, disableDrivewayNewCarLeadForms })) {
    return false;
  }

  return isTopEmbeddedLeadFormEnabled(vinData, location);
};
